import { sin, cos } from '@/utils/translate'

export const styleData = [
    { key: 'left', label: 'X坐标' },
    { key: 'top', label: 'Y坐标' },
    { key: 'width', label: '宽' },
    { key: 'height', label: '高' },
    { key: 'color', label: '颜色' },
    { key: 'backgroundColor', label: '背景色' },
    { key: 'borderWidth', label: '边框宽度' },
    { key: 'borderStyle', label: '边框风格' },
    { key: 'borderColor', label: '边框颜色' },
    { key: 'borderRadius', label: '边框半径' },
    { key: 'fontSize', label: '字体大小' },
    { key: 'fontWeight', label: '字体粗细' },
    { key: 'img', label: '图片' },
    { key: 'className', label: '图标' },
    { key: 'lineHeight', label: '行高' },
    { key: 'letterSpacing', label: '字间距' },
    { key: 'textAlign', label: '左右对齐' },
    { key: 'verticalAlign', label: '上下对齐' },
    { key: 'opacity', label: '透明度' },
    { key: 'lineWidth', label: '折线宽度' },
    { key: 'lineColor', label: '折线颜色' },
    { key: 'smooth', label: '平滑曲线' },
    { key: 'symbolShow', label: '显示拐点' },
    { key: 'labelShow', label: '显示标签' },
    { key: 'lineItemColor', label: '拐点颜色' },
    { key: 'barItemColor', label: '柱条颜色' },
    { key: 'barWidth', label: '柱条宽度' },
    { key: 'toolShow', label: '显示工具栏' },
    { key: 'xname', label: 'X轴名称' },
    { key: 'yname', label: 'Y轴名称' },
    { key: 'sname', label: '系列名称' },
    { key: 'legendShow', label: '显示图例' },
    { key: 'mode', label: '深色模式' },
]

export function getStyle(style, filter = []) {
    const needUnit = [
        'fontSize',
        'width',
        'height',
        'top',
        'left',
        'borderWidth',
        'letterSpacing',
        'borderRadius',
    ]

    const result = {}
    Object.keys(style).forEach(key => {
        if (!filter.includes(key)) {
            if (key != 'rotate') {
                result[key] = style[key]

                if (needUnit.includes(key)) {
                    result[key] += 'px'
                }
            } else {
                result.transform = key + '(' + style[key] + 'deg)'
            }
        }
    })
    // console.log(result)
    return result
}

// 获取一个组件旋转 rotate 后的样式
export function getComponentRotatedStyle(style) {
    style = { ...style }
    if (style.rotate != 0) {
        const newWidth = style.width * cos(style.rotate) + style.height * sin(style.rotate)
        const diffX = (style.width - newWidth) / 2 // 旋转后范围变小是正值，变大是负值
        style.left += diffX
        style.right = style.left + newWidth

        const newHeight = style.height * cos(style.rotate) + style.width * sin(style.rotate)
        const diffY = (newHeight - style.height) / 2 // 始终是正
        style.top -= diffY
        style.bottom = style.top + newHeight

        style.width = newWidth
        style.height = newHeight
    } else {
        style.bottom = style.top + style.height
        style.right = style.left + style.width
    }

    return style
}
